export default __webpack_public_path__ + "static/media/x.b248550e.svg";